"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Popover_1 = __importDefault(require("@material-ui/core/Popover"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
const os_1 = require("../../utils/os");
const utils_1 = require("../../utils/utils");
require("../../styles/components/popover.less");
const getOpenStatus = (isOpen, anchorEl) => (isOpen !== null ? isOpen : Boolean(anchorEl));
function PopoverWrapper(props) {
    const { triggerComponent, popoverPlacements, openOnHover, transformOrigin, className, children, onClose, forceClose, backgroundGreyed, isOpen, onOpen, fixContainer, triggerClassName, anchorEl: propAnchor, container: propContainer, shouldDisableOnClickWithCtrlOrShift, disablePortal, disableAutoFocus, hideBackdrop, ...restProps } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(propAnchor || null);
    const anchor = (0, react_1.useRef)(null);
    const prevForceClose = (0, usePrevious_1.default)(forceClose);
    const openStatus = getOpenStatus(isOpen, anchorEl);
    const [container, setContainer] = (0, react_1.useState)(propContainer);
    const popoverId = (0, react_1.useMemo)(() => `material-ui-popover-wrapper-${(0, utils_1.generateUUID)()}`, []);
    const handleClick = (0, react_1.useCallback)((event) => {
        if (shouldDisableOnClickWithCtrlOrShift && (0, os_1.ctrlOrShiftPressed)(event)) {
            return;
        }
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setContainer(propContainer || event.currentTarget.parentNode);
        if (onOpen) {
            onOpen();
        }
    }, [shouldDisableOnClickWithCtrlOrShift, onOpen, propContainer]);
    const handleClose = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    (0, react_1.useEffect)(() => {
        if (prevForceClose !== forceClose && forceClose) {
            setAnchorEl(null);
        }
    }, [prevForceClose, forceClose]);
    (0, react_1.useEffect)(() => {
        if (isOpen && !anchorEl && anchor && anchor.current) {
            setAnchorEl(anchor.current);
        }
    }, [isOpen, anchorEl, anchor]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        triggerComponent ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('popover-trigger-wrapper', {
                'popover-trigger-open': openStatus,
                [triggerClassName]: triggerClassName,
            }), ref: anchor, onClick: handleClick, onMouseEnter: openOnHover ? handleClick : noop_1.default, onMouseLeave: openOnHover ? handleClose : noop_1.default }, triggerComponent)) : (''),
        children && (react_1.default.createElement(Popover_1.default, { id: popoverId, classes: {
                root: (0, classnames_1.default)('popover-root-class', {
                    'popover-root-disable-pointer-event': openOnHover,
                }),
                paper: className,
            }, open: !!openStatus, anchorEl: anchorEl || document.body, container: fixContainer ? container : undefined, onClose: handleClose, BackdropProps: { invisible: !backgroundGreyed }, anchorOrigin: popoverPlacements, transformOrigin: transformOrigin, disablePortal: disablePortal, disableAutoFocus: openOnHover || disableAutoFocus, hideBackdrop: openOnHover || hideBackdrop, ...restProps }, children))));
}
exports.default = PopoverWrapper;
PopoverWrapper.defaultProps = {
    triggerComponent: '',
    className: '',
    triggerClassName: '',
    popoverPlacements: {
        vertical: 'bottom',
        horizontal: 'center',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
    onClose: null,
    forceClose: false,
    backgroundGreyed: false,
    isOpen: null,
    onOpen: null,
    fixContainer: false,
    openOnHover: false,
    anchorEl: null,
    container: undefined,
    PaperProps: {},
    shouldDisableOnClickWithCtrlOrShift: false,
    options: [],
    dropdownClass: '',
    stopClickPropagation: false,
    disablePortal: false,
    children: null,
    disableAutoFocus: false,
    hideBackdrop: false,
};
PopoverWrapper.propTypes = {
    triggerComponent: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]),
    triggerClassName: prop_types_1.default.string,
    className: prop_types_1.default.string,
    popoverPlacements: prop_types_1.default.shape({
        vertical: prop_types_1.default.oneOf(['top', 'center', 'bottom']),
        horizontal: prop_types_1.default.oneOf(['left', 'center', 'right']),
    }),
    transformOrigin: prop_types_1.default.shape({
        vertical: prop_types_1.default.oneOf(['top', 'center', 'bottom']),
        horizontal: prop_types_1.default.oneOf(['left', 'center', 'right']),
    }),
    onClose: prop_types_1.default.func,
    forceClose: prop_types_1.default.bool,
    backgroundGreyed: prop_types_1.default.bool,
    isOpen: prop_types_1.default.bool,
    onOpen: prop_types_1.default.func,
    fixContainer: prop_types_1.default.bool,
    openOnHover: prop_types_1.default.bool,
    anchorEl: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.object]),
    container: prop_types_1.default.object,
    PaperProps: prop_types_1.default.object,
    shouldDisableOnClickWithCtrlOrShift: prop_types_1.default.bool,
};
//# sourceMappingURL=popover.js.map